import { Component, OnInit } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, LoaderService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-stanje-po-valutama',
  templateUrl: './stanje-po-valutama.component.html'
})
export class StanjePoValutamaComponent extends BaseCommonComponent implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected loaderService: LoaderService,
    protected toastrService: NotificationService
  ) {
    super(activatedRoute, userService, baseDataService, translateService, modalService, toastrService, loaderService);
   }

  Config={}
  mainItems=[]

  baseFormGroup:FormGroup=new FormGroup({
    DatumOd:new FormControl()
    ,DatumDo:new FormControl()
  })

  get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;

  chartItems: List<List<any>> = List([List([])]);

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("DatumOd", Validators.required, 'required', 'STANJEPOVALUTAMA.DATUMOD.VALIDATION.REQUIRED');
    this.addValidatorToFc("DatumDo", Validators.required, 'required', 'STANJEPOVALUTAMA.DATUMDO.VALIDATION.REQUIRED');
  }

  OnModelDataLoaded(){
    super.OnModelDataLoaded();
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }

  }

  OnDataLoaded(){
    super.OnDataLoaded();
    //this.chartItems = List([List([])]);
    this.chartItems = this.chartItems.clear();
    this.chartItems = this.chartItems.push(this.items);
  }
  
}
